import { i18n } from '@/plugins/i18n'

export const templateStatus = {
    ACTIVE: 1,
    NOT_ACTIVE: 2,
}

export const templateStatusStr = {
    ACTIVE: i18n.t('online_contract.status.active'),
    NOT_ACTIVE: i18n.t('online_contract.status.not_active'),
    get(status) {
        let status_str = null;
        Object.keys(templateStatus).forEach(function (item) {
            if(templateStatus[item] === status) {
                status_str = templateStatusStr[item]
            }
        })

        return status_str
    }
}

export const templateStatusVariant = (status) => {
    if(status === templateStatus.ACTIVE) {
        return 'success'
    }

    if(status === templateStatus.NOT_ACTIVE) {
        return 'danger'
    }

    return 'info'
}

export const contractStatus = {
    PENDING : 0,
    SIGNED : 1,
    END : 2,
}

export const contractStatusStr = {
    PENDING: i18n.t('online_contract.status.pending'),
    SIGNED: i18n.t('online_contract.status.signed'),
    END: i18n.t('online_contract.status.end'),
    get(status) {
        let status_str = null;
        Object.keys(contractStatus).forEach(function (item) {
            if(contractStatus[item] === status) {
                status_str = contractStatusStr[item]
            }
        })

        return status_str
    }
}

export const contractStatusVariant = (status) => {
    if(status === contractStatus.SIGNED) {
        return 'success'
    }

    if(status === contractStatus.PENDING) {
        return 'warning'
    }

    return 'info'
}